export interface MoodEntry {
  id: string;
  user_id: string;
  mood_value: number;
  mood_label: string;
  notes: string | null;
  is_public: boolean;
  created_at: string;
}

export interface MoodOption {
  value: number;
  label: string;
  emoji: string;
  color: string;
  bgColor: string;
}

export const MOOD_OPTIONS: MoodOption[] = [
  { value: 1, label: 'Struggling', emoji: '😔', color: 'text-red-500', bgColor: 'bg-red-100 dark:bg-red-900/30' },
  { value: 2, label: 'Low', emoji: '😕', color: 'text-orange-500', bgColor: 'bg-orange-100 dark:bg-orange-900/30' },
  { value: 3, label: 'Neutral', emoji: '😐', color: 'text-yellow-500', bgColor: 'bg-yellow-100 dark:bg-yellow-900/30' },
  { value: 4, label: 'Good', emoji: '🙂', color: 'text-lime-500', bgColor: 'bg-lime-100 dark:bg-lime-900/30' },
  { value: 5, label: 'Great', emoji: '😊', color: 'text-green-500', bgColor: 'bg-green-100 dark:bg-green-900/30' },
];
